"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("../constants");
/**
 * SIG credit card icon
 * https://www.figma.com/file/Fh5RdpXA9VEhcfr9m4nM0s/SIG---Iconography?type=design&node-id=1073-9319&mode=dev
 */
function CreditCardIcon(props) {
    const { className, "data-testid": dataTestId, fill = "#000000", size = constants_1.Sizes.Large } = props;
    return ((0, jsx_runtime_1.jsxs)("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", className: className, "data-testid": dataTestId, children: [(0, jsx_runtime_1.jsx)("rect", { x: "3", y: "5", width: "18", height: "14", rx: "2", stroke: fill, strokeWidth: "1", strokeLinejoin: "round" }), (0, jsx_runtime_1.jsx)("rect", { x: "3", y: "8", width: "18", height: "4", fill: fill })] }));
}
exports.CreditCardIcon = CreditCardIcon;
//# sourceMappingURL=index.js.map